import * as Generated from './generated/AnalyticsBeacons'

// Alias the really long namespaces then re-export them in more consumable forms
// These are pretty common structs.
import ApplicationID = Generated.ApplicationID
import Base = Generated.Base
import Budget = Generated.Budget
import Publisher = Generated.Publisher
import Flyer = Generated.Flyer
import Merchant = Generated.Merchant
import FlyerItem = Generated.FlyerItem
import UserAccount = Generated.UserAccount

export {
    ApplicationID,
    Base,
    Budget,
    Publisher,
    Flyer,
    FlyerItem,
    Merchant,
    UserAccount,
}
